import {
  IconButton,
  Menu,
  MenuItem,
  MenuPopup,
  MenuTrigger,
} from "@assetwatch/ui";
import { useTranslation } from "react-i18next";

export function EnterpriseProfileMenu({
  canViewReleaseInfo,
  onOpenReleaseInfo,
  onSignOut,
}: {
  canViewReleaseInfo: boolean;
  onOpenReleaseInfo: () => void;
  onSignOut: () => void;
}) {
  const { t } = useTranslation();

  return (
    <Menu>
      <MenuTrigger
        render={
          <IconButton
            aria-label={t("enterprise.chrome.account.openMenuAriaLabel")}
            icon="user"
            size="md"
            variant="outline"
          />
        }
      />
      <MenuPopup align="end" size="sm">
        {canViewReleaseInfo ? (
          <MenuItem leadingIcon="document" onClick={onOpenReleaseInfo}>
            {t("enterprise.chrome.releaseInfo.triggerSubtitle")}
          </MenuItem>
        ) : null}
        <MenuItem
          data-testid="nav-sign-out"
          leadingIcon="logout-exit"
          onClick={onSignOut}
          tone="destructive"
        >
          {t("enterprise.common.signOut")}
        </MenuItem>
      </MenuPopup>
    </Menu>
  );
}
